export const APP_NAME = 'Retrend AI';
export const APP_DESCRIPTION =
  'Bringing powerful AI Analysis to your Retail Customers.';
